import { Header, IllustrationError } from '@bbl-digital/snorre'
import styled from '@emotion/styled'
import React from 'react'

export const ErrorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
  justify-content: center;
  align-items: center;

  font-family: 'Source Sans Pro', sans-serif;

  & > div {
    margin-bottom: 3em;
  }
`

const PageError: React.FC = () => (
  <ErrorWrapper>
    <IllustrationError />
    <Header level={2}>Ops! Her har det skjedd en feil...</Header>
  </ErrorWrapper>
)

export default PageError
